<template>
  <div>
    <van-nav-bar title="自助落箱" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <van-form @submit="onSubmit">
      <van-field readonly clickable name="picker" :value="yard_name" label="堆场" placeholder="点击选择堆场"
                 @click="showPicker = true"/>
      <van-popup v-model="showPicker" position="bottom" :style="{ height: '50%' }">
        <van-picker show-toolbar :columns="yard_list" @confirm="onConfirm" @cancel="showPicker = false"
                    :default-index="0" :visible-item-count="6"/>
      </van-popup>
      <van-field v-model="boxno" name="boxno" maxlength="11" label="箱号" placeholder="箱号"/>
      <van-field readonly clickable name="box_model" :value="box_model" label="箱型" placeholder="点击选择箱型"
                 @click="showBoxModel = true"/>
      <van-popup v-model="showBoxModel" position="bottom">
        <van-picker show-toolbar :columns="box_model_list" @confirm="onBoxModelConfirm" @cancel="showBoxModel = false"/>
      </van-popup>
      <van-field readonly clickable name="box_weight" :value="box_weight" label="空重箱" placeholder="点击选择空重箱"
                 @click="showBoxWeight = true"/>
      <van-popup v-model="showBoxWeight" position="bottom">
        <van-picker show-toolbar :columns="box_weight_list" @confirm="onBoxWeightConfirm"
                    @cancel="showBoxWeight = false"/>
      </van-popup>
      <van-field v-model="daibox_fee" name="daibox_fee" type="digit" label="代箱费"/>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Form, Picker} from 'vant';

Vue.use(Picker);
Vue.use(Form);

export default {
  data() {
    return {
      boxno: '',
      daibox_fee: '',
      showPicker: false,
      yard_name: '',
      yard_id: -1,
      yard_list: [],
      switchChecked: false,
      box_model: '',
      box_model_list: [{values: ["40", "20", "45"]}, {values: ['GP', 'HC', 'HQ', 'FR', 'RF', 'OT', 'RQ']}],
      showBoxModel: false,
      box_weight: '',
      box_weight_list: ["重箱", "空箱"],
      showBoxWeight: false,
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push({path: "/container-yard/home"});
    },
    onConfirm(value, index) {
      this.yard_name = value;
      this.yard_id = index;
      this.showPicker = false;
    },
    onBoxModelConfirm(value, index) {
      this.box_model = value[0] + value[1];
      this.showBoxModel = false;
    },
    onBoxWeightConfirm(value, index) {
      this.box_weight = value;
      this.showBoxWeight = false;
    },
    onSubmit(values) {
      let querystring = require("querystring");
      this.$api.post("wx/container-yard/in",
          querystring.stringify({
            boxno: values.boxno,
            box_model: values.box_model,
            box_weight: values.box_weight,
            daibox_fee: values.daibox_fee,
            yard_name: this.yard_name,
            yard_id: this.yard_id,
            name: localStorage.getItem("name"),
            carno: localStorage.getItem("carno"),
            tel: localStorage.getItem("tel"),
          })
      ).then(({data}) => {
        if (data.status == 1) {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
            this.$router.push({path: "/container-yard/home"});
          });
        } else {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
          });
        }
      });
    },
    //获取列表
    getYardList() {
      this.$api.post('wx/container-yard/yardList',
      ).then(data => {
        if (data.data.status == 1) {
          this.yard_list = data.data.data;
          for (let i = 0; i < data.data.data.length; i++) {
            this.yard_list[i] = data.data.data[i].yard_name;
          }
        } else {
          Dialog.alert({
            message: data.data.msg,
          }).then(() => {

          });
        }
      }).catch(err => {
        console.log(err);
      })
    },
  },
  mounted() {
    this.getYardList();
    //console.log(this.yard_list);
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/container-yard/in.vue